/**
 * Показать спиннер.
 *
 * @function ShowSpinner
 * @ignore
 */
function ShowSpinner() {
  $.when(WA.FormControlsInit).done(() => {
    WA.CR.spinner.show();
  });
}

/**
 * Скрыть спиннер.
 *
 * @function HideSpinner
 * @ignore
 */
function HideSpinner() {
  $.when(WA.FormControlsInit).done(() => {
    WA.CR.spinner.hide();
  });
}

/**
 * Показать сообщение.
 *
 * @function ShowInlineHint
 * @param {string} message - Текст сообщения.
 * @param {MESSAGE_TYPE} type - Тип сообщения.
 * @param {INLINE_HINT_PRIORITY} [inlineHintPriority] Приоритет встроенной подсказки
 * @ignore
 */
function ShowInlineHint(message, type, inlineHintPriority) {
  $.when(WA.FormControlsInit).done(() => {
    WA.CR.inlineHint.show(message, null, type, inlineHintPriority);
  });
}